import React from "react"
import { withRouter, Link } from "react-router"
import Article from "../modules/Article"
//import Helmet from "react-helmet";
import contributeMessages from "../../messages/imageUpload"
import settingsMessages from "../../messages/settings"
import { FormattedMessage, injectIntl, FormattedHTMLMessage } from "react-intl"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { getAccountSettings } from "../../scripts/accountSettings"
import { replaceMarkdownLinks } from "../../scripts/utils"
import { apiAuth } from "../../api"
import { filterHTML } from "../../scripts/xss"

class WriteArticle extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      saved: false,
      done: false,
      id: null,
      user: {}
    }
  }

  componentWillMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave)
  }

  componentDidMount() {
    apiAuth("get", "user").then(values => this.setState({ user: values }))
  }

  render() {
    const { intl } = this.props
    const done = this.state.done
    const articleStyle = done ? "default" : "article"
    const {
      settings: {
        static_texts: { contribution_message: contributionMessage }
      }
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    return (
      <main
        id="main"
        role="main"
        data-article-style={articleStyle}
        tabIndex={0}
      >
        {!done && (
          <Article
            user={this.state.user}
            editing={true}
            canEdit={true}
            resource={null}
            handleSave={this._handleSave}
          />
        )}
        {done && (
          <article className="c-article min-height-page">
            <section className="image-upload-area single-column single-column--skinny">
              <div style={getStyles("thanks-for-your-contribution")}>
                <p className="lead mbs">
                  <FormattedMessage {...contributeMessages.thankYou} />
                </p>
                <p
                  className="mbm"
                  dangerouslySetInnerHTML={{
                    __html: replaceMarkdownLinks(
                      filterHTML(contributionMessage)
                    )
                  }}
                />
              </div>

              <ul
                className="list--inline"
                style={getStyles("thanks-for-your-contribution__list--inline")}
              >
                {getStyleTag("button--white")}
                <li>
                  <Link
                    className="button"
                    to={"/item/" + this.state.id}
                    style={getStyles([
                      "save-article-final-buttons",
                      "c_button__bordered"
                    ])}
                  >
                    <FormattedMessage {...contributeMessages.viewMyStory} />
                  </Link>
                </li>
                {/*<li><button className="button" onClick={this._writeAnother}>Write another story</button></li>*/}
                <li>
                  <Link
                    className="button button--white"
                    to="/contribute/"
                    style={getStyles([
                      "save-article-final-buttons",
                      "c_button__bordered",
                      "c_button__bordered--white",
                      "button--white"
                    ])}
                  >
                    <FormattedMessage
                      {...contributeMessages.addSomethingElse}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    className="button button--white"
                    to="/search"
                    style={getStyles([
                      "save-article-final-buttons",
                      "c_button__bordered",
                      "c_button__bordered--white",
                      "button--white"
                    ])}
                  >
                    <FormattedMessage {...contributeMessages.browseTheSite} />
                  </Link>
                </li>
              </ul>
            </section>
          </article>
        )}
      </main>
    )
  }

  _handleSave = res => {
    console.log("RES", res)
    this.setState({
      id: res.resource_id,
      done: res.access_rights !== "draft",
      saved: true
    })
  }

  _writeAnother = () => {
    this.setState({
      saved: false
    })
  }

  routerWillLeave = () => {
    if (!this.state.saved) {
      return this.props.intl.formatMessage(
        contributeMessages.unsavedInformation
      )
    }
  }
}

export default withRouter(injectIntl(WriteArticle))



// WEBPACK FOOTER //
// ./webapp/components/pages/WriteArticle.js